import * as React from 'react';
import { Route } from 'react-router';
import { Redirect } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import Layout from './components/Layout';
import Counter from './components/Counter';
import FetchData from './components/FetchData';
import ProductSearch from './components/ProductSearch';
import IssuedOrders from './components/IssuedOrders';
import OrderIntake from './components/OrderIntake';
import SendReceipt from './components/SendReceipt';
import SignIn from './components/SignIn';
import InventoryMove from './components/InventoryMove';
import TemporaryPositionsList from './components/TemporaryPositionsList';
import TemporaryPositionDetail from './components/TemporaryPositionDetail';
import PositionStocktaking from './components/PositionStocktaking';
import SkuStocktaking from './components/SkuStocktaking';
import RecommendedMoves from './components/RecommendedMoves';
import IncomingGoodsIntake from './components/IncomingGoodsIntake';

import './style.css'

const App = () => {
    return (
        <>
            <Route exact path='/auth' render={() => <Redirect to='/' />} />
            <AuthenticatedTemplate>
                <Layout>
                    <Route exact path='/' component={IncomingGoodsIntake} />
                    <Route path='/counter' component={Counter} />
                    <Route path='/fetch-data/:startDateIndex?' component={FetchData} />
                    <Route path='/product-search' component={ProductSearch} />
                    <Route exact path='/incoming' component={IncomingGoodsIntake} />
                    <Route exact path='/order-intake' component={IssuedOrders} />
                    <Route exact path='/order-intake/:selectedOrderNumber' component={OrderIntake} />
                    <Route exact path='/order-intake/:selectedOrderNumber/send-receipt' component={SendReceipt} />
                    <Route exact path='/inventory-move' component={InventoryMove} />
                    <Route exact path='/temporary-positions' component={TemporaryPositionsList} />
                    <Route exact path='/temporary-positions/:positionId/organize' component={TemporaryPositionDetail} />
                    <Route exact path='/position-stocktaking' component={PositionStocktaking} />
                    <Route exact path='/sku-stocktaking' component={SkuStocktaking} />
                    <Route exact path='/recommended-moves' component={RecommendedMoves} />
                </Layout>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <SignIn />
            </UnauthenticatedTemplate>
        </>
    );
};

export default App;
